import { gql } from '@apollo/client';
import eventFieldsFragment from './eventFragment';
import eventAssignmentsFragment from './eventAssignmentsFragment';

const SUBMIT_EVENT = gql`
  mutation SubmitEvent($event: EditEventInput!) {
    submitEvent(event: $event) {
      ...EventFields
      EventAssignments {
        ...EventAssignmentsFields
      }
    }
  }

  ${eventFieldsFragment}
  ${eventAssignmentsFragment}
`;

export default SUBMIT_EVENT;
